import * as types from '../../constants/log/nftRentalLogConstants';

export const nftRentalLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  callback,
  error,
}) => ({
  type: types.NFT_RENTAL_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  callback,
  error,
});
